// ======================================================================
// File Name       : UnsubmittedReportAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import { decamelizeKeys, camelizeKeys } from 'humps';
import _ from 'lodash';
import moment from 'moment';
import store from '../../store';
import { commonCallApi } from '../../utils/ApiUtils';
import { REPORT_STATUS, REPORT_STATUS_NOT_SUBMITTED, USER_TYPE } from '../../constants/KeyValueConstants';
import { SELECT_TARGET_DATA } from '../../constants/index';
import * as actionCreators from '../actionCreators/report/unsubmitted';
import * as userAction from '../UserAction';
import { DATA_LIMIT_FLAG } from '../../constants/GroupConstants';

export function searchUnsubmittedReport() {
  return async (dispatch, getState) => {
    const state = getState();
    const { form, unsubmittedReport } = state;
    let searchForm = {};
    if (form.unsubmittedReportSearchForm) {
      const { unsubmittedReportSearchForm } = form;
      searchForm = unsubmittedReportSearchForm.values;
    }
    const isUserName = searchForm.userName !== '';
    const { unsubmittedReportList } = unsubmittedReport;
    const { searchInfo } = unsubmittedReportList;
    const params = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        reportStatusList: [REPORT_STATUS_NOT_SUBMITTED],
        reportName: searchForm ? searchForm.reportName : undefined,
        includeDeadlineReportFlg: searchForm && searchForm.includeDeadlineReportFlg ? 1 : 0,
        reportHistorySortType: searchInfo.reportHistorySortType === null ? undefined : searchInfo.reportHistorySortType,
        ascendingDescendingSort: searchInfo.ascendingDescendingSort || 0,
        startPosition: searchInfo.startPosition,
        returnMaxNum: searchInfo.returnMaxNum,
      },
    };
    const groupListRequest = [];
    if (searchInfo && searchInfo.selectedGroup && searchInfo.selectedGroup.groupSecernId) {
      groupListRequest.push(searchInfo.selectedGroup.groupSecernId);
    }
    let userList = [];
    if (isUserName) {
      if (groupListRequest.length > 0) {
        userList = await userAction.searchUserCustomParams(
          { userName: searchForm.userName, groupList: groupListRequest, userType: USER_TYPE.STUDENT });
      } else {
        userList = await userAction.searchUserCustomParams(
          { userName: searchForm.userName, userType: USER_TYPE.STUDENT });
      }
      params.searchInfo.userList = userList;
    } else {
      params.searchInfo.groupList = groupListRequest;
    }
    if ((isUserName || (isUserName && groupListRequest.length)) &&
        (!userList || !userList.length)) {
      const result = { recordNum: 0, reportList: [] };
      return dispatch(actionCreators.receiveUnsubmittedReportSearch(result));
    }
    return dispatch(getUnsubmittedReport(params));
  };
}

export function getUnsubmittedReport(searchInfo) {
  return (dispatch) => {
    const params = { ...searchInfo };
    return commonCallApi({
      path: 'reportOperation/GetList',
      data: params,
    })
      .then((result) => {
        dispatch(actionCreators.receiveUnsubmittedReportSearch(result));
        const userResultList = [];
        const listLength = result && result.reportList ? result.reportList.length : 0;
        for (let i = 0; i < listLength; i++) {
          const report = result.reportList[i];
          if (report.submitterUserSecernId && userResultList.indexOf(report.submitterUserSecernId) < 0) {
            userResultList.push(report.submitterUserSecernId);
          }
        }
        if (userResultList && userResultList.length > 0) {
          dispatch(searchUser({ userSecernIdList: userResultList }));
        }
      });
  };
}

export function getGroupList() {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      dataLimitFlag: DATA_LIMIT_FLAG.LIMIT,
    };
    commonCallApi({
      path: 'group/GetStructure',
      data: param,
      institutionId: 1,
    }).then((camelizeJson) => {
      dispatch(actionCreators.receiveGroupList(camelizeJson));
    });
  };
}

export function resetUnsubmittedReport() {
  return (dispatch) => {
    dispatch(actionCreators.receiveReportResetInit());
  };
}

export function initUnsubmittedReportList() {
  return (dispatch) => {
    dispatch(getGroupList());
    return dispatch(searchUnsubmittedReport());
  };
}

export function updateUnsubmittedReportSearchInfo(searchInfo) {
  return (dispatch) => {
    dispatch(actionCreators.receiveUpdateSearchInfo(searchInfo));
  };
}

export function searchUser(params) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        ...params,
      },
    };
    return commonCallApi({
      path: 'user/GetList',
      data: param,
      institutionId: 1,
    }).then((response) => {
      const { userList } = response;
      dispatch(actionCreators.receiveUserList(userList));
    });
  };
}
